<template>
    <div class="blog-sidebar-item">
        <h1 class="heading-border-bottom-anim" v-if="title">{{title}}</h1>

        <div class="search-box">
            <el-input
            placeholder="Search here..."
            class="input-with-select"
            >
                <template #append>
                    <el-button class="search-icon"><el-icon><Search /></el-icon></el-button>
                </template>
            </el-input>
        </div>

    </div>
</template>

<script>
import { Search } from '@element-plus/icons-vue'

export default {
    name: 'SearchBox',
    props: {
        title: {
            type: String,
            default: 'Search'
        }
    },
    components: {
        Search
    },
    data() {
        return {

        }
    }
}
</script>